import React from 'react';
import  { Typography, Checkbox } from '@ann/web-components';
import {StyledCard, CardContainer, CardWrapper, CheckBoxWrapper} from "./ModalListCard.styled";

const ModalListCard = ({id, title, description, isChecked = false, onChange}) => {
    const handleCardClick = (e) => {
      // Do not execute if the click comes from the checkbox
      if (e.target.closest('[data-checkbox-wrapper]')) {
        return;
      }
      if (onChange) {
        onChange();
      }
    };

    const handleCheckboxChange = (e) => {
      e?.stopPropagation?.();
      if (onChange) {
        onChange();
      }
    };

    return (
        <div>
          <StyledCard onClick={handleCardClick} selected={isChecked}>
            <CardWrapper>
              <CardContainer>
                <Typography category="subtitle" size="small" weight="bold">
                  {title}
                </Typography>
                <Typography category="body" size="small" weight="regular" color="body">
                  {description}
                </Typography>
              </CardContainer>
              <CheckBoxWrapper data-checkbox-wrapper onClick={(e) => e.stopPropagation()}>
                <Checkbox 
                  checked={isChecked}
                  onChange={handleCheckboxChange} 
                  size="small"
                />
              </CheckBoxWrapper>
            </CardWrapper>
          </StyledCard>
        </div>
    );
}

export default ModalListCard;